import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=92d5f92a&scoped=true"
import script from "./LoginFooter.vue?vue&type=script&lang=js"
export * from "./LoginFooter.vue?vue&type=script&lang=js"
import style0 from "./LoginFooter.vue?vue&type=style&index=0&id=92d5f92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d5f92a",
  null
  
)

export default component.exports